import React from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import RaportPopup from '../../../views/components/RaportPopup';
import { useAppSelector } from '../../../redux-file/hooks';
import DownloadIcon from '@mui/icons-material/Download';

export default function DownloadReportItem() {
  const { t } = useTranslation();
  const [popupOpen, setPopupOpen] = React.useState(false);
  const activeOrg = useAppSelector(
    (state) => state.platform.activeOrganization
  );
  const reportingFreq = activeOrg?.co2?.reporting_freq;

  return (
    <ListItem>
      {reportingFreq && (
        <RaportPopup
          opened={popupOpen}
          setOpened={setPopupOpen}
          reportingFreq={reportingFreq}
          organizationIds={[activeOrg.id]}
        />
      )}
      <ListItemButton onClick={() => setPopupOpen(true)}>
        <ListItemIcon>
          <DownloadIcon />
        </ListItemIcon>
        <ListItemText primary={t('menu.download-report')} />
      </ListItemButton>
    </ListItem>
  );
}
